interface AppConfig {
  SERVER_BASE_URL?: string
  WEBSITE_BASE_URL?: string
  KEYCLOAK_URL?: string
  KEYCLOAK_REALM?: string
  KEYCLOAK_CLIENT_ID?: string
}

const runtime: AppConfig = (window as unknown as { __APP_CONFIG__?: AppConfig }).__APP_CONFIG__ ?? {}

// `||` (not `??`): the entrypoint writes empty strings for unset env vars; an empty value must fall
// back to the build-time `define:` default (dev keeps using .env.local / localhost).
export const serverBaseUrl = runtime.SERVER_BASE_URL || SERVER_BASE_URL
export const websiteBaseUrl = runtime.WEBSITE_BASE_URL || WEBSITE_BASE_URL
export const keycloakUrl = runtime.KEYCLOAK_URL || KEYCLOAK_URL
export const keycloakRealm = runtime.KEYCLOAK_REALM || KEYCLOAK_REALM
export const keycloakClientId = runtime.KEYCLOAK_CLIENT_ID || KEYCLOAK_CLIENT_ID
